// extracted by mini-css-extract-plugin
module.exports = {"getInspiredContainer":"GetInspired_getInspiredContainer__ki_If","allCollections":"GetInspired_allCollections__zUQth","sectionTitle":"GetInspired_sectionTitle__laXZy"};